export default __webpack_public_path__ + "d66c9c2e45e6c07dfc8eab08e3743680.jpg";